/* eslint-disable react/prop-types */
/* eslint-disable semi */
import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Input,
  FormGroup,
  Label,
} from 'reactstrap';

class PlanogramGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.planogram || [],
      image: props.image || {},
      product: props.product || {},
    };
  }

  handleChange = (index, field, value) => {
    const updated = [...this.state.items];
    updated[index][field] = value;
    this.setState({ items: updated });

    if (this.props.onEdit) {
      this.props.onEdit(updated);
    }
  };

  render() {
    const { items } = this.state;
    const { product: productMap, image: imageMap } = this.props;
    return (
      <Container fluid className="my-3">
        <Row>
          {items.map((item, index) => {
            const productName =
              productMap?.[item.product] || item.nameProduct || '';
            const productImage = imageMap?.[item.product] || "https://firebasestorage.googleapis.com/v0/b/iotera-vending.appspot.com/o/bottleBlank.png?alt=media&token=be603fed-c9c9-4783-bf7e-d015cafc9a64";
            return (
              <Col md="3" sm="6" xs="12" key={item.selection} className="mb-4">
                <Card className="h-100">
                  {/* Gambar produk */}
                  <CardImg
                    top
                    src={productImage}
                    alt={productName}
                    style={{
                      maxHeight: '150px',
                      objectFit: 'contain',
                      backgroundColor: '#f8f9fa',
                    }}
                  />

                  <CardBody>
                    {/* Selection */}
                    <CardText className="text-muted">
                      No: {item.selection}
                    </CardText>

                    {/* Nama produk (editable) */}
                    <CardTitle tag="h5">
                      <Input
                        type="text"
                        value={productName}
                        onChange={e =>
                          this.handleChange(
                            index,
                            'nameProduct',
                            e.target.value
                          )
                        }
                      />
                    </CardTitle>

                    {/* Price */}
                    <CardText>
                      Price (Rp):{' '}
                      <Input
                        type="number"
                        value={item.price}
                        onChange={e =>
                          this.handleChange(index, 'price', e.target.value)
                        }
                      />
                    </CardText>

                    {/* Stock */}
                    <CardText>
                      Stock:{' '}
                      <Input
                        type="number"
                        value={item.stock}
                        onChange={e =>
                          this.handleChange(index, 'stock', e.target.value)
                        }
                      />
                    </CardText>

                    {/* Active */}
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={item.active === 'on'}
                          onChange={e =>
                            this.handleChange(
                              index,
                              'active',
                              e.target.checked ? 'on' : 'off'
                            )
                          }
                        />{' '}
                        Active
                      </Label>
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    );
  }
}

export default PlanogramGrid;
